import creator from './creator'

export const createTravelStore = function (options) {
  const state = creator.createState(options)

  const getters = {
    listForm: (state) => {
      return {
        tabName: 0
      }
    }
  }

  const mutations = {
  }

  const actions = {
    syncListRouteParams ({ state, getters, commit }, params) {
      return new Promise((resolve, reject) => {
        var errors = [] // keep error object name

        if (errors.length > 0) {
          reject(new Error(errors.join(',')))
        } else {
          resolve(getters.listForm)
        }
      })
    }
  }

  return {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
}



// WEBPACK FOOTER //
// ./src/configs/store/modules/travel/index.js